import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const session_id = sp.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!session_id) { setStatus("error"); return; }
    let mounted = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${session_id}`);
        if (!mounted) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (attempts > 10) { setStatus("timeout"); return; }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch {
        setStatus("error");
      }
    };
    poll();
    return () => { mounted = false; };
  }, [session_id, attempts]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <Card className="max-w-md w-full border-slate-200">
        <CardContent className="p-10 text-center">
          {status === "polling" && (<><Loader2 className="w-14 h-14 text-teal-600 mx-auto animate-spin" /><h2 className="font-display font-bold text-2xl mt-4">Confirming payment…</h2></>)}
          {status === "paid" && (
            <>
              <div className="w-16 h-16 rounded-full bg-teal-100 flex items-center justify-center mx-auto"><CheckCircle2 className="w-9 h-9 text-teal-600" /></div>
              <h2 className="font-display font-bold text-3xl mt-5 text-slate-900">Payment secured</h2>
              <p className="text-slate-600 mt-2">Payment protected — funds are held by CLEANBAZ until the booking is marked complete. Your job is now live in the dispatch pool.</p>
              <Button className="mt-6 bg-slate-900 hover:bg-slate-800 text-white" onClick={() => nav("/dashboard")} data-testid="pay-to-dash">Go to dashboard</Button>
            </>
          )}
          {(status === "error" || status === "timeout") && (
            <>
              <XCircle className="w-14 h-14 text-red-500 mx-auto" />
              <h2 className="font-display font-bold text-2xl mt-4">Something went wrong</h2>
              <Button className="mt-6" variant="outline" onClick={() => nav("/dashboard")}>Go to dashboard</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <Card className="max-w-md w-full">
        <CardContent className="p-10 text-center">
          <XCircle className="w-14 h-14 text-amber-500 mx-auto" />
          <h2 className="font-display font-bold text-2xl mt-4">Payment cancelled</h2>
          <p className="text-slate-600 mt-2">No charges were made. You can try again anytime.</p>
          <Button className="mt-6 bg-teal-600 text-white" onClick={() => nav("/")}>Back to home</Button>
        </CardContent>
      </Card>
    </div>
  );
}
